export default {"src":"/_next/static/media/DOCUMENT_ICON.57a63a72.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};